import { IBeautyPlace,IBeautyPlaceData } from "./BeautifulPlaces.model";
import { INews, INewsData } from "./news.model";
export class News implements INews{
    readonly id: number
    title?: string
    text?: string

    constructor(data?: INews) {
        this.id = data?.id || 0
        this.title = data?.title || ''
        this.text = data?.text || ''
      }
      validate(): boolean {
        let id = this.id
        return !!id && id > 0
      }
      update(data?: INews | undefined): void {
          this.title = data?.title
          this.text = data?.text
      }

}
export class BeautyPlace extends News implements IBeautyPlace {
  images: string[];
   constructor(data?: IBeautyPlace) {
    super(data)
    this.images = data?.images || []
  }
}